const gql = String.raw;
  
export const ImpactStory = gql`
query ImpactStoryBySlugQuery($slug: ID!) {
  impactStory(id: $id) {
    
      id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
    
    openGraph { 
      id title description { id text }
      image { 
        id url url2x 
        thumbnails { id halfBanner { url url2x } } } 
    }
    stage { id name slug }
    quotes {
      person {
        id name
        organisation { id name }
      }
      description { id text }
    }
    people { id name slug }
    longitude
    latitude
    resultTypes {    id name slug typeLabel badge path updated __typename _schema { label pluralLabel }  }
    imageAssets {
      id name slug alternateText description { text }
      image { 
        id url url2x type width height thumbnails { mainBanner { url url2x } } 
      }
    }
    documents {
      id name path slug typeLabel badge updated __typename _schema { label pluralLabel }
      content { id plain text }
      description { id text }
      files {
        id name slug
        file { id url extension }
      }
      type { id name slug __typename }
    }
    indicatorResults {
      id value slug numericValue year __typename _schema { label pluralLabel }
      indicator { 
        id 
        color { id value }
        unit { id name shorthand valueType { id slug } } 
        subtitle title
      }
    }
    entityViews {
      id name hash label slug count showCount
      type { id name slug }
      slices {
        id name slug label updated
        title 
        titleRich { id text }
        layout { id name slug component }
        themeMode { id name slug }
        link { id url name label slug __typename }
        openGraph {
          id
          image { url thumbnails { large { url } bubble { url url2x } } }
        }
        relatedSolutions {
          
            
          
              id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
            
            
                  openGraph { 
                    id title 
                    
                    image { 
                      id url url2x 
                      thumbnails { 
                        id bubbleMedium { id url url2x }
                      }
                      
                    } 
                  }
                
           
          space { id name }
          location { id name
            state { id name abbr }
          }
        }
        videos {
          id name url __typename _schema { label pluralLabel }
          openGraph { image { thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        programs {
          # nNot querying program path - no layout
          id name slug typeLabel badge updated __typename _schema { label }
          openGraph { id image { url url2x thumbnails { bubble { url url2x } } } }
        }
        documents {
          id name slug typeLabel badge updated __typename _schema { label }
          type { id name slug __typename }
          content { id text }
          description { id text }
          folder { id name slug }
          owner {
            id name slug path __typename
            openGraph { image { thumbnails { bubble { url url2x } } } }
          }
          files {
            id name slug
            file { id url extension }
          }
        }
        headerFontType { internalName }
        bodyFontType { internalName }
        disabled
        connectedEntities { name label internalName }
        entityLayout { internalName }
        created updated
        outro { id text }
        intro { id text }
        stage { id name slug typeLabel badge updated __typename _schema { label } }
        resultTypes { id name slug typeLabel badge updated __typename _schema { label } }
        spaces {          id name slug typeLabel badge path updated __typename _schema { label pluralLabel }                openGraph {            id title                       image {              id url url2x              thumbnails {                id bubbleMedium { id url url2x }             }                        }          }         }
        content { 
          id plain text 
          linkEmbeds { 
              id name _label url slug __typename
              image { id url width height }
            } 
          linkRichEmbeds { 
            id name _label url slug __typename
            image { id url width height }
          }
        }
        email
        phone
        twitter
        threads
        linkedin
        backgroundColor { id value }
        color { id value }
        teams { id name slug __typename _schema { label pluralLabel } }
        objectives { id name slug __typename type { id name slug __typename } }
        icon { id slug name component }
        embeds {
          posts {
            id name slug path
            openGraph {
              title description { plain(truncate: {words: 20}) }
              image { url url2x type }
            }
          }
          imageAssets {
            id
            slug
            image {
              id url url2x width height type 
            }
          }
        }
        images {
          id name slug alternateText description { text }
          image { 
            id url url2x type width height thumbnails { mainBanner { url url2x } } 
          }
        }
        people {
          id name slug path __typename
          organisation { id name }
          linkedin
          position
          openGraph { id image { thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        indicators { 
          id name slug title
        }
        indicatorGroups { 
          id slug name 
        }
        economies {
          id name slug path __typename _schema { label pluralLabel }
          openGraph { id image { url url2x thumbnails { bubble { url url2x } } } }
        } 
        locations { 
          id name slug __typename _schema { label pluralLabel } 
          openGraph { id image { url url2x thumbnails { bubble { url url2x } } } }
        }
        posts { 
           
             
           
              id name slug typeLabel badge path updated __typename _schema { label pluralLabel } 
           
             
             
                  openGraph {  
                    id title  
                     
                    image {  
                      id url url2x  
                      thumbnails {  
                        id bubbleMedium { id url url2x } 
                      } 
                       
                    }  
                  } 
                 
          
          type { id name slug }
        }
        feedEntries {
          name id slug url __typename _schema { label pluralLabel }
          type { id name slug }
          typeLabel
          openGraph { id title image { url url2x thumbnails { full { url url2x } } } }
        }
        pages {
          
            
          
              id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
            
            
                  openGraph { 
                    id title 
                    
                    image { 
                      id url url2x 
                      thumbnails { 
                        id bubbleMedium { id url url2x }
                      }
                      
                    } 
                  }
                
          
          type { id name slug }
        }
        organisations { 
          id name slug path __typename _schema { label pluralLabel }
          openGraph { id image { url url2x thumbnails { bubble { url url2x } card { url url2x } } } }
        }
        events {
          
            
          
              id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
            
            
                  openGraph { 
                    id title 
                    
                    image { 
                      id url url2x 
                      thumbnails { 
                        id bubbleMedium { id url url2x }
                      }
                      
                    } 
                  }
                
          
        }
        eventRoles {
          
            id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
          
          role { 
              
                
              
                id name slug typeLabel badge path updated __typename _schema { label pluralLabel } 
              
                
                
                    openGraph {  
                      id title  
                        
                      image {  
                        id url url2x  
                        thumbnails {  
                          id bubbleMedium { id url url2x } 
                        } 
                          
                      }  
                    } 
                    
            
          }
          event {
            
              
            
                id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
            
              
              
                    openGraph { 
                      id title 
                      
                      image { 
                        id url url2x 
                        thumbnails { 
                          id bubbleMedium { id url url2x }
                        }
                        
                      } 
                    }
                  
            
            title
            type { id name slug }
          }
        }
      }
    }
  }
}
`;
